import { GenInternalLink } from '@/components/generics';

import {
  CLICKED_ITEM_TYPES,
  CTA_NAMES,
  trackItemClickedEvent,
} from '@/utils/rudderstack';

import {
  buildRelativeInternalUrl,
  buildQueryString,
} from '@/utils/shopSubdomain';

import { ItemSelectorProps } from '../../ItemSelector';

type EditChildProps = {
  id: string;
  cta: string;
  trackPageLocation: ItemSelectorProps['trackPageLocation'];
};

const EditChild = ({ id, cta, trackPageLocation }: EditChildProps) => {
  if (!id) return null;

  const handleClick = () => {
    trackItemClickedEvent({
      url: window.location.href,
      type: CLICKED_ITEM_TYPES.LINK,
      pageLocation: trackPageLocation,
      cta: CTA_NAMES.EDIT_CHILD,
    });
  };

  const _generateEditChildLink = (childUuid: string) => {
    const queryString = buildQueryString([
      {
        key: 'page_source',
        value: 'subscriptions',
      },
    ]);

    return buildRelativeInternalUrl(
      ['account', 'v2', 'settings', 'edit-child', childUuid],
      queryString,
    );
  };

  return (
    <GenInternalLink
      classes="flex-col text-center font-bold text-blue-deep underline text-sm lg:text-base"
      cta={cta}
      href={_generateEditChildLink(id)}
      onClick={() => handleClick()}
    />
  );
};

export default EditChild;
